import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getStoresBasedOnDomainAction } from "../../redux/actions";
import { getImageUrl } from "../../utils";
import CustomLoader from "../UI/CustomLoader";
import PlaceHolderImg from "../../assets/images/PlaceholderImage.png";
import UpdateDateMacrosInString from "../UI/UpdateDateMacrosInString";
import NewsLetter from "../Home/NewsLetter";
import Advertistment from "./Advertistment";

function Stores() {
  const dispatch = useDispatch();

  const { storesList, loading } = useSelector((state) => state.Stores);
  const { domainData } = useSelector((state) => state.Website);
  let groupedData = [];
  let activeStoresList = storesList.filter(
    (ele) => ele.is_archived === false && ele.is_paused === false
  );
  const sortedByNamestoresList = activeStoresList.sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  //filtering
  if (sortedByNamestoresList) {
    for (var i = 0; i < sortedByNamestoresList.length; i++) {
      let temp = [sortedByNamestoresList[i]];
      for (var j = i + 1; j < sortedByNamestoresList.length; j++) {
        if (
          sortedByNamestoresList[i].name[0].toUpperCase() ===
          sortedByNamestoresList[j].name[0].toUpperCase()
        ) {
          temp.push(sortedByNamestoresList[j]);
          i = j;
        }
      }
      groupedData.push(temp);
    }
  }

  useEffect(() => {
    dispatch(getStoresBasedOnDomainAction());
  }, [dispatch]);

  return (
    <div>
      <div
        style={{
          border: "1px solid rgb(227, 226, 222)",
          borderRadius: "8px",
          background: "#fff",
          margin: "10px",
        }}
      >
        <Advertistment />
      </div>

      {loading ? (
        <CustomLoader />
      ) : (
        <div className="container">
          <h2 className="allStore">All Stores</h2>
          <div className="row " style={{ background: "#fff" }}>
            <div className="col-sm-3">
              <div className="vertical-menu">
                {groupedData.map((data, key) => (
                  <a
                    className="item"
                    href={`#charachter-${data[0].name[0]}`}
                    key={key}
                  >
                    {data[0]?.name[0]?.toUpperCase()}
                    <div>
                      {" "}
                      <span className="badge">{data.length}</span>{" "}
                    </div>
                  </a>
                ))}
              </div>
            </div>
            <div className="col-sm-9" style={{ padding: "1rem" }}>
              <h4>Featured Stores</h4>
              <div className="row" style={{ padding: "0.5rem" }}>
                {groupedData.slice(0, 8).map((data, key) => (
                  <div className="col-sm-3 " key={key}>
                    <div className="featured-stores">
                      <Link to={`/store/${data[0].slug}`}>
                        <img
                          src={getImageUrl(data[0]?.image, PlaceHolderImg)}
                          alt={data[0].name}
                          style={{
                            height: "100%",
                            width: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mTop-30">
                {groupedData.map((data, key) => (
                  <div
                    key={key}
                    className="p-10 store"
                    style={{
                      borderLeft: `3px solid ${
                        domainData?.header_color || "#ff9900"
                      }`,
                    }}
                  >
                    <div>
                      <h5
                        id={`charachter-${data[0].name[0]}`}
                        style={{
                          color: domainData?.header_color || "#ff9900",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                      >
                        Stores - {data[0].name[0].toUpperCase()}
                      </h5>
                      <div className="row">
                        {data.map((store, key) => (
                          <div className="col-sm-3" key={key}>
                            {/* &gt; {} */}
                            <Link
                              to={`/store/${store.slug}`}
                              className="link-text"
                            >
                              <p
                                style={{
                                  margin: "0",
                                  fontSize: "14px",
                                  fontWeight: "400",
                                }}
                              >
                                <UpdateDateMacrosInString input={store.name} />
                              </p>
                            </Link>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      <NewsLetter />
    </div>
  );
}

export default Stores;
